export const LISTENING_PRELOAD_WINDOW = 3;
export const AUDIO_PRELOAD_TIMEOUT_MS = 15000;

export const isListeningQuestion = (question) =>
  question?.Category === "Listening";

export const getQuestionId = (question) =>
  question?.QuestionId !== undefined && question?.QuestionId !== null
    ? String(question.QuestionId)
    : "";

export const getListeningAudioUrl = (questionData) => {
  const firstAudio = questionData?.AudioObjects?.[0];
  return firstAudio?.url || firstAudio?.audio_url || questionData?.audio_url || "";
};

export const getListeningQuestionsFromStep = (questions = [], currentStep = 1) =>
  questions
    .slice(Math.max(0, currentStep - 1))
    .filter(isListeningQuestion);

export const getListeningPreloadBatches = (
  questions = [],
  preloadWindow = LISTENING_PRELOAD_WINDOW
) => {
  const listeningQuestions = questions.filter(isListeningQuestion);

  return {
    initialQuestions: listeningQuestions.slice(0, preloadWindow),
    backgroundQuestions: listeningQuestions.slice(preloadWindow),
  };
};

export const getPreloadReadyCount = (
  questions = [],
  audioStatusByQuestionId = {},
  preloadWindow = LISTENING_PRELOAD_WINDOW
) => {
  return questions
    .filter(isListeningQuestion)
    .slice(0, preloadWindow)
    .filter((question) => audioStatusByQuestionId[getQuestionId(question)] === "ready")
    .length;
};

export const isTerminalAudioStatus = (status) =>
  status === "ready" || status === "error" || status === "no-audio";

export const preloadAudioUrl = (
  audioUrl,
  {
    timeoutMs = AUDIO_PRELOAD_TIMEOUT_MS,
    AudioCtor = typeof Audio !== "undefined" ? Audio : null,
  } = {}
) => {
  if (!audioUrl) {
    return Promise.resolve("no-audio");
  }

  if (!AudioCtor) {
    return Promise.resolve("ready");
  }

  return new Promise((resolve) => {
    const audio = new AudioCtor();
    let settled = false;

    const cleanup = () => {
      audio.removeEventListener("canplaythrough", onReady);
      audio.removeEventListener("canplay", onReady);
      audio.removeEventListener("loadeddata", onReady);
      audio.removeEventListener("error", onError);
    };

    const finish = (status) => {
      if (settled) return;
      settled = true;
      cleanup();
      resolve(status);
    };

    const onReady = () => finish("ready");
    const onError = () => finish("error");

    audio.preload = "auto";
    audio.addEventListener("canplaythrough", onReady);
    audio.addEventListener("canplay", onReady);
    audio.addEventListener("loadeddata", onReady);
    audio.addEventListener("error", onError);
    audio.src = audioUrl;

    try {
      audio.load();
    } catch (error) {
      finish("error");
      return;
    }

    setTimeout(() => finish("error"), timeoutMs);
  });
};
